<template>
  <form class="form form-loyalty-signup-sides mb-0" @submit.prevent="postSides">
    <slide-x-left-transition :duration="400" :delay="300">
      <div class="form-group" v-show="show">
        <label>Imię:</label>
        <div class="input-wrapper">
          <input type="text"
                 v-model="contractor_first_name"
                 :class="{'input-error' : errors['contractor_data.first_name'] }"
                 placeholder="Imię">
          <p class="error"
             v-if="errors['contractor_data.first_name']"
             v-text="errors['contractor_data.first_name'][0]">
          </p>
        </div>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="400" :delay="400">
      <div class="form-group" v-show="show">
        <label>Nazwisko:</label>
        <div class="input-wrapper">
          <input type="text"
                 v-model="contractor_last_name"
                 :class="{'input-error' : errors['contractor_data.last_name'] }"
                 placeholder="Nazwisko">
          <p class="error"
             v-if="errors['contractor_data.last_name']"
             v-text="errors['contractor_data.last_name'][0]">
          </p>
        </div>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="400" :delay="500">
      <p v-show="show">Dane firmy / lokalu (autouzupełnione).</p>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="400" :delay="600">
      <div class="form-group" v-show="show">
        <label>Nip firmy:</label>
        <div class="input-wrapper">
          <input type="number"
                 v-model="tax_id"
                 :class="{'input-error' : errors['company_data.tax_id'] }"
                 v-mask="'##########'"
                 placeholder="Nip firmy">
        </div>
        <p class="error" v-if="errors['company_data.tax_id']" v-text="errors['company_data.tax_id'][0]"></p>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="400" :delay="700">
      <div class="form-group" v-show="show">
        <label>Miasto:</label>
        <div class="input-wrapper">
          <input type="text"
                 v-model="city"
                 :class="{'input-error' : errors['company_data.city'] }"
                 placeholder="Miasto">
        </div>
        <p class="error" v-if="errors['company_data.city']" v-text="errors['company_data.city'][0]"></p>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="400" :delay="800">
      <div class="form-group" v-show="show">
        <label>Ulica</label>
        <div class="input-wrapper">
          <input type="text"
                 v-model="street"
                 :class="{'input-error' : errors['company_data.street'] }"
                 placeholder="Ulica i numer domu">
        </div>
        <p class="error" v-if="errors['company_data.street']" v-text="errors['company_data.street'][0]"></p>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="400" :delay="900">
      <div class="form-group" v-show="show">
        <label>Numer domu:</label>
        <div class="input-wrapper">
          <input type="text"
                 v-model="street_no"
                 :class="{'input-error' : errors['company_data.street_no'] }"
                 placeholder="Ulica i numer domu">
        </div>
        <p class="error" v-if="errors['company_data.street_no']" v-text="errors['company_data.street_no'][0]"></p>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="400" :delay="1000">
      <div class="form-group" v-show="show">
        <label>Kod pocztowy:</label>
        <div class="input-wrapper">
          <input type="text"
                 v-model="zip_code"
                 :class="{'input-error' : errors['company_data.zip_code'] }"
                 v-mask="'##-###'"
                 placeholder="Kod pocztowy">
        </div>
        <p class="error" v-if="errors['company_data.zip_code']" v-text="errors['company_data.zip_code'][0]"></p>
      </div>
    </slide-x-left-transition>

    <slide-x-left-transition :duration="400" :delay="1100">
      <p v-show="show">Podaj dane Przedstawieciela Handlowego.</p>
    </slide-x-left-transition>

    <slide-x-left-transition :duration="400" :delay="1200">
      <div class="form-group" v-show="show">
        <label>Imię:</label>
        <div class="input-wrapper">
          <input type="text"
                 v-model="sales_representative_first_name"
                 :class="{'input-error' : errors['sales_representative_data.first_name'] }"
                 placeholder="Imię">
        </div>
        <p class="error"
           v-if="errors['sales_representative_data.first_name']"
           v-text="errors['sales_representative_data.first_name'][0]">
        </p>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="400" :delay="1300">
      <div class="form-group" v-show="show">
        <label>Nazwisko:</label>
        <div class="input-wrapper">
          <input type="text"
                 v-model="sales_representative_last_name"
                 :class="{'input-error' : errors['sales_representative_data.last_name'] }"
                 placeholder="Nazwisko">
        </div>
        <p class="error"
           v-if="errors['sales_representative_data.last_name']"
           v-text="errors['sales_representative_data.last_name'][0]">
        </p>
      </div>
    </slide-x-left-transition>
    <slide-y-up-transition :duration="500" :delay="400">
      <div v-if="show">
        <ion-button mode="ios"
                    fill="outline"
                    size="small"
                    @click="goToStep(0)"
                    class="mt-10">Wstecz
        </ion-button>
        <ion-button mode="ios"
                    size="small"
                    @click="postSides"
                    class="mt-10">Przejdź dalej
        </ion-button>
      </div>
    </slide-y-up-transition>
  </form>
</template>

<script>
  import { createHelpers } from 'vuex-map-fields';
  import {mapState} from "vuex";

  const { mapFields } = createHelpers({
    getterType: `loyalty/getField`,
    mutationType: `loyalty/updateField`,
  });

  export default {
    name: 'FormLoyaltySignupActivationSides',
    computed: {
      ...mapFields({
        tax_id : 'signupActivationForm.company_data.tax_id',
        city : 'signupActivationForm.company_data.city',
        street : 'signupActivationForm.company_data.street',
        street_no : 'signupActivationForm.company_data.street_no',
        zip_code : 'signupActivationForm.company_data.zip_code',
        contractor_first_name: 'signupActivationForm.contractor_data.first_name',
        contractor_last_name: 'signupActivationForm.contractor_data.last_name',
        sales_representative_first_name: 'signupActivationForm.sales_representative_data.first_name',
        sales_representative_last_name: 'signupActivationForm.sales_representative_data.last_name',
      }),
      ...mapState({
        errors: state => state.loyalty.errors,
      })
    },
    data() {
      return {
        show: false,
      }
    },
    mounted(){
      this.show = true
    },
    methods: {
      goToStep(step){
        this.$store.commit('loyalty/LOYALTY_SET_SIGNUP_ACTIVATION_CURRENT_STEP', step)
      },
      postSides(){
        this.$store.dispatch('loyalty/LOYALTY_CONTRACT_ACTIVATION_STORE_REQUEST', 2)
      }
    }
  }
</script>